import { Component, inject, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { getBrowserCultureLang, TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { LocalStorageService } from "@services/local-storage.service";
import { DxButtonModule } from "devextreme-angular/ui/button";

@Component({
    selector: "app-not-authorized",
    imports: [TranslocoPipe, RouterLink, DxButtonModule],
    templateUrl: "./not-authorized.component.html",
    styleUrls: ["./not-authorized.component.css"]
})
export class NotAuthorizedComponent implements OnInit {
    language: string;

    private localStorageService = inject(LocalStorageService);
    private translocoService = inject(TranslocoService);

    ngOnInit(): void {
        this.translocoService.setAvailableLangs(["pt-BR", "en-US", "es-ES"]);
        const browserLang = getBrowserCultureLang();
        this.language = this.localStorageService.get("lang")
            ? browserLang.match(/pt-BR|es-ES|en-US/)
                ? browserLang
                : "en-US"
            : browserLang;

        this.translocoService.setActiveLang(this.language);
    }
}
